import app from 'flarum/forum/app';
app.initializers.add('val-ui-mobile-submit-near-preview', () => {
  let scheduled = false;
  const sync = () => {
    const composer = document.querySelector('.Composer');
    const floating = composer?.querySelector('.PreviewEyeFloating');
    const original = composer?.querySelector('.TextEditor-controls > .item-submit > button');
    if (!floating) return;
    let proxy = floating.querySelector('.val-mobile-submit-proxy');
    if (!proxy) {
      proxy = document.createElement('button');
      proxy.type = 'button';
      proxy.className = 'Button Button--icon hasIcon val-mobile-submit-proxy';
      proxy.setAttribute('aria-label', 'Envoyer');
      proxy.setAttribute('title', 'Envoyer');
      proxy.innerHTML = '<i aria-hidden="true" class="icon fas fa-paper-plane Button-icon"></i>' + '<span class="Button-label"><span class="Button-labelText">Envoyer</span></span>';
      proxy.addEventListener('click', event => {
        event.preventDefault();
        event.stopPropagation();
        const submit = document.querySelector('.Composer .TextEditor-controls > .item-submit > button');
        if (submit && !submit.disabled) {
          submit.click();
        }
      });
      floating.appendChild(proxy);
    }
    const disabled = !original || original.disabled;
    if (proxy.disabled !== disabled) {
      proxy.disabled = disabled;
    }
    proxy.classList.toggle('loading', !!original?.classList.contains('loading'));
  };
  const schedule = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      sync();
    });
  };
  const observer = new MutationObserver(schedule);
  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['class', 'disabled']
  });
  window.addEventListener('resize', schedule);
  schedule();
});